import type { BreadcrumbItem } from './index';

export function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  const visibleItems = items.filter((item) => item.text !== null);

  if (visibleItems.length < 2 || visibleItems.some((item) => !item.text?.trim())) {
    return null;
  }

  const itemListElement = visibleItems.map((item, index) => {
    let url: string | undefined;

    if (item.href) {
      try {
        const parsed = new URL(item.href, 'https://getapet.com');
        if (parsed.protocol === 'https:' || parsed.protocol === 'http:') {
          url = parsed.href;
        }
      } catch {
        // A visible breadcrumb can still be rendered without structured data.
      }
    }

    return {
      '@type': 'ListItem' as const,
      position: index + 1,
      name: item.text,
      ...(url ? { item: url } : {}),
    };
  });

  // Google permits the final item to omit its URL; earlier items need one.
  if (itemListElement.slice(0, -1).some((item) => !item.item)) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };
}
